export default __webpack_public_path__ + "static/media/okara-logo-header.02ff325b.png";